/** Hours between two `HH:mm` strings, rounded to 1 decimal. Shared by
 *  OnLeaveTodayCard and UpcomingLeaveCard so their hourly-leave duration
 *  math can't drift apart. */
export function getLeaveHours(startTime: string, endTime: string) {
  const toMinutes = (time: string) => {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  };
  const diff = toMinutes(endTime) - toMinutes(startTime);
  return diff > 0 ? Math.round((diff / 60) * 10) / 10 : 0;
}

const LOW_BALANCE_THRESHOLD = 0.2;

/** True once 20% or less of a leave type's total allotment remains. */
export function isLowBalance(available: number, total: number) {
  return total > 0 && available / total <= LOW_BALANCE_THRESHOLD;
}

/** Local (not UTC) parse of a `YYYY-MM-DD` string — `dayjs(dateStr)` defers
 *  to native `Date` parsing for date-only ISO strings, which reads them as
 *  UTC midnight and can shift the calendar day by one in negative-UTC-offset
 *  timezones. */
export function parseLocalDate(dateStr: string) {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}
